// needs to be a separate file from Toolbar to avoid circular imports between Toolbar <-> SavedReplies

import {ActionBar, type IconButtonProps} from '@primer/react'
import {use} from 'react'

import {MarkdownEditorContext} from './MarkdownEditorContext'
import styles from './ToolbarButton.module.css'

type ToolbarButtonProps = IconButtonProps & {ref?: React.Ref<HTMLButtonElement>}

export const ToolbarButton = ({ref, ...props}: ToolbarButtonProps) => {
  const {disabled} = use(MarkdownEditorContext)

  return (
    <ActionBar.IconButton
      ref={ref}
      variant="invisible"
      disabled={disabled}
      // Prevent focus leaving input:
      onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
      {...props}
      className={styles.iconButton}
    />
  )
}
ToolbarButton.displayName = 'MarkdownEditor.ToolbarButton'
